
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'billing-portal-ui',
  currentProjectVersion: 'static-1.2103',
  depVersions: {
  "billing-portal-ui": "static-1.2103",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.496",
  "foundations-components-test-utils": "static-1.5982",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8336",
  "hub-http-shared-msw-handlers": "static-1.10621",
  "hubspot-dlb": "static-2.1882",
  "portals-platform-bend-plugin": "static-1.22",
  "react-dlb": "static-1.88",
  "reselect": "static-3.12",
  "billing-portal-service-types": "static-1.1941",
  "commerce-products-lib": "static-1.10530",
  "commerce-shared-components-lib": "static-1.19224",
  "customer-data-objects": "static-1.7996",
  "customer-data-properties": "static-1.52602",
  "customer-data-property-utils": "static-1.8406",
  "data-fetching-client": "static-1.9959",
  "foundations-assets": "static-1.5190",
  "foundations-components": "static-1.8499",
  "foundations-theming": "static-1.4781",
  "framework-data-table": "static-2.12554",
  "hub-http": "static-1.6518",
  "HubStyleTokens": "static-2.11794",
  "I18n": "static-7.1674",
  "meetings-icalendar-utils-lib": "static-1.941",
  "metrics-js": "static-1.9867",
  "object-builder-ui-client": "static-1.49677",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1458",
  "property-translator": "static-1.5699",
  "purchase-motions-components": "static-1.6368",
  "quartz-config": "static-1.1239",
  "quartz-core": "static-1.6680",
  "quartz-routing": "static-1.891",
  "quick-fetch": "static-1.4131",
  "raven": "static-3.5925",
  "react": "static-7.192",
  "react-dom": "static-7.85",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1.17026",
  "redux": "static-4.76",
  "redux-toolkit": "static-1.78",
  "rpc-client-utils": "static-1.4971",
  "sanitize-text": "static-1.8459",
  "smart-property-lib": "static-1.8298",
  "styled-components": "static-2.95",
  "ui-addon-form-validation": "static-1.11287",
  "ui-addon-i18n": "static-1.11452",
  "ui-addon-iframeable": "static-1.9381",
  "ui-addon-react-router-dom": "static-1.9840",
  "ui-addon-upgrades": "static-9.18390",
  "UIComponents": "static-3.8740",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4297",
  "immutable": "static-2.83",
  "bend-plugin-trellis-migration": "static-1.3622",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3738",
  "quartz-webpack": "static-1.3685",
  "bend-plugin-quartz-routing": "static-1.539",
  "foundations-components-legacy": "static-1.1524",
  "HeadJS": "static-2.797",
  "quartz": "static-1.7461",
  "framer-motion": "static-1.79",
  "hs-test-utils-bend-plugin": "static-1.3447",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "ts-schema": "static-1.4296",
  "webpack-env": "static-1.54",
  "bender-build-tools": "static-1.3444",
  "commerce-permissions": "static-1.1081",
  "customer-data-tracking": "static-1.7187",
  "growth-payments-core": "static-1.26181",
  "hs-resources": "static-1.496",
  "hubspot-apollo-client": "static-1.5182",
  "immer": "static-1.101",
  "products-iframe-lib": "static-1.8594",
  "products-ui-components-shared-msw-handlers": "static-1.11003",
  "pulse": "static-1.934",
  "transmute": "static-2.97",
  "batch-promise": "static-1.1849",
  "crm_data": "static-4.92831",
  "cssUtils": "static-1.926",
  "customer-data-associations": "static-1.7631",
  "customer-data-objects-ui-components": "static-1.13335",
  "framework-data-schema-resolvers": "static-1.7197",
  "frontend-preferences-client": "static-1.8227",
  "graphql": "static-1.89",
  "hs-lodash": "static-4.45",
  "hs-story-utils": "static-1.9729",
  "HubStyle": "static-2.12101",
  "icons": "static-2.683",
  "payments-enrollment-embed-lib": "static-1.23835",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5558",
  "stripe-embedded-components": "static-1.8001",
  "StyleGuideUI": "static-3.502",
  "ui-addon-opt": "static-4.8668",
  "ui-images": "static-2.1249",
  "usage-tracker-container": "static-1.7627",
  "usage-tracker-core": "static-1.7487",
  "inbound-db-properties-service-client": "static-1.4055",
  "ai-components-ui-library": "static-1.9719",
  "atom": "static-1.5391",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2786",
  "calling-global-api": "static-1.65626",
  "calling-internal-common": "static-1.31626",
  "calling-lifecycle-internal": "static-1.67008",
  "calling-lifecycle-messages": "static-1.59302",
  "conditional-properties-service-client": "static-1.4016",
  "crm-index-visualization-core": "static-1.4546",
  "crm-links": "static-1.6634",
  "crm-message-bus": "static-1.43764",
  "crm-pipelines-api-client-types": "static-1.4349",
  "customer-data-properties-shared-msw-handlers": "static-1.9948",
  "external-options-client-types": "static-1.4340",
  "file-manager-components": "static-1.24502",
  "formula-editor": "static-1.14771",
  "google-libphonenumber": "static-1.45",
  "hs-promise-utils": "static-1.5900",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbounddb-objects-service-types": "static-1.4428",
  "multi-currency-client-types": "static-1.3911",
  "PatternValidationJS": "static-1.3198",
  "pipeline-validation-client-types": "static-1.4183",
  "property-value-citations": "static-1.3216",
  "quartz-i18n": "static-1.1136",
  "reference-resolvers-lite": "static-1.8408",
  "SharedI18nStrings": "static-1.183",
  "smart-data-capture-core": "static-1.144",
  "tiered-pricing": "static-1.1958",
  "topics-actions-lib": "static-1.471",
  "trial-components-library": "static-1.14110",
  "usage-tracker": "static-1.7637",
  "user-context": "static-1.5425",
  "zustand": "static-1.85",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4768",
  "floating-ui": "static-1.63",
  "foundations-theming-specialty": "static-1.2497",
  "react-aria": "static-1.72",
  "react-create-root-preference": "static-1.70",
  "react-virtualized": "static-2.107",
  "tanstack-table": "static-1.61",
  "trellis-assets": "static-1.2651",
  "ui-fonts": "static-1.1056",
  "bend-plugin-foundations-theming": "static-1.3264",
  "foundations-theming-base": "static-1.3766",
  "stylex": "static-1.41",
  "customer-data-reference-ui-components": "static-1.13482",
  "customer-data-ui-utilities": "static-1.10133",
  "tasks-actions-lib": "static-1.128",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "redux-thunk": "static-2.80",
  "reference-resolvers": "static-1.8486",
  "reporting-data": "static-1.68827",
  "sanitize": "static-1.4777",
  "tanstack-virtual": "static-1.38",
  "ui-addon-draggable": "static-3.5064",
  "hs-locale-management": "static-1.296",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.91",
  "interframe": "static-3.5060",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.6051",
  "laboratory-lib": "static-3.7457",
  "merchandise-lib": "static-1.278",
  "onboarding-scopes": "static-1.6757",
  "purchase-motions-api": "static-1.6371",
  "signup-constants": "static-1.19632",
  "signup-ui-url-generator": "static-2.8365",
  "opentelemetry-fe-types": "static-1.77",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.879",
  "hubspotter-http": "static-1.4865",
  "jasmine": "static-4.4618",
  "jasmine-runner": "static-1.6756",
  "mobile-manifest-mixins": "static-1.576",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.452",
  "quartz-auth": "static-1.1136",
  "quartz-head": "static-1.1126",
  "quartz-test": "static-1.1136",
  "quartz-tracking": "static-1.840",
  "trellis-components": "static-1.2670",
  "csstype": "static-1.50",
  "web-vitals": "static-1.15",
  "bend-plugin-chirp-manifest": "static-1.381",
  "chirp-fetch": "static-1.2198",
  "data-agent-kit": "static-1.652",
  "data-token-picker": "static-1.16892",
  "feedback-loader": "static-1.29814",
  "markdown-it": "static-1.6",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10704",
  "fsm": "static-1.4054",
  "policy-lib": "static-1.7106",
  "react-colorpicker": "static-2.10522",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10767",
  "magpie-lib": "static-1.5757",
  "navigation-messaging": "static-1.8163",
  "salesImages": "static-1.567",
  "seat-types-lib": "static-1.729",
  "apollo-link-hub-http": "static-2.4961",
  "event-emitter": "static-1.1258",
  "framework-builder-read-service-client": "static-1.4222",
  "fdsr-migration-layer": "static-1.316",
  "hubspot-apollo-cache": "static-1.641",
  "sales-views-client-types": "static-1.4561",
  "bend-plugin-pulse": "static-1.437",
  "fast-json-patch": "static-1.70",
  "crm_universal": "static-1.22499",
  "customer-data-email": "static-1.18529",
  "native-integrations-shared-strings": "static-1.8082",
  "superstore": "static-1.5063",
  "sassPrefix": "static-1.197",
  "framework-data-schema-quick-fetch": "static-1.7102",
  "persist-promise": "static-1.4006",
  "copilot-toolkit": "static-1.11851",
  "growth-onboarding-confetti": "static-1.3366",
  "growth-onboarding-feedback-components": "static-1.6889",
  "growth-onboarding-reliability": "static-1.5386",
  "marketplace-ui-apps-core": "static-1.19263",
  "onboarding-tours": "static-1.17122",
  "stripe-connect-js": "static-1.76",
  "chatspot-core": "static-1.23034",
  "ContentUtils": "static-1.69128",
  "calling-error-reporting": "static-1.31633",
  "shared-worker-versioning": "static-1.11346",
  "calling-usage-tracker": "static-1.6841",
  "voice-sms-access-library": "static-1.2059",
  "conversations-skeleton-state": "static-1.7551",
  "react-immutable-render-mixin": "static-1.9",
  "crm-index-associations-lib": "static-1.6745",
  "location-customization-utils-lib": "static-1.10097",
  "restore-request-side-panel-lib": "static-1.1679",
  "breeze-engine-lib": "static-1.1739",
  "immerable": "static-1.4452",
  "video-components-external": "static-1.12148",
  "video-data-lib": "static-1.35806",
  "bark-lib": "static-1.16817",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.102",
  "crm-properties-common-lib": "static-1.6193",
  "react-codemirror": "static-1.10945",
  "embedded-academy-lib": "static-1.15521",
  "hubs-service-types": "static-1.1564",
  "navigation-components": "static-1.18836",
  "getting-started-shared-tasks": "static-1.19240",
  "getting-started-shared-tasks-store": "static-1.18358",
  "onboarding-tours-utils": "static-1.1189",
  "stylex-utils": "static-1.141",
  "trellis-theming": "static-1.1279",
  "react-dnd-compat": "static-1.4922",
  "reporting-client-types": "static-1.2687",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.78",
  "usage-tracker-anonymous": "static-1.6054",
  "usage-tracker-public": "static-1.7448",
  "opentelemetry-web": "static-1.13",
  "hubspotter-http-shared-msw-handlers": "static-1.10619",
  "usage-tracker-session-replay": "static-1.5323",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "highcharts": "static-8.111",
  "trellis-story-utils": "static-1.4812",
  "storybook-react": "static-1.40",
  "idb-keyval": "static-1.51",
  "magpie-types": "static-1.5217",
  "reactive-lib": "static-1.1023",
  "simple-logging-lib": "static-1.3356",
  "FormUrlGenerator": "static-2.5031",
  "sequences-lib": "static-1.8534",
  "FileManagerCore": "static-1.40001",
  "FileManagerLib": "static-1.40142",
  "timezone-utils": "static-2.5548",
  "ui-gdpr-components": "static-1.10625",
  "developer-experience-shared-components": "static-1.10845",
  "immutable-less": "static-1.4955",
  "marketplace-ui-client-types": "static-1.18138",
  "marketplace-ui-common": "static-1.20731",
  "ui-addon-integrations-directory-panel": "static-2.8331",
  "ui-extensibility-client-types": "static-1.4223",
  "ui-universal-auth": "static-1.9412",
  "growth-data-modal": "static-1.5900",
  "growth-onboarding-next-action-utils": "static-1.2687",
  "onboarding-tours-client": "static-1.5337",
  "ui-shepherd-react": "static-3.10575",
  "ui-shepherd-tracker": "static-1.7956",
  "cms-field-types": "static-1.5118",
  "content-icons-ui": "static-1.2368",
  "integrations-lib": "static-1.17036",
  "underscore": "static-1.8",
  "calling-orchestration-schema": "static-1.36836",
  "crm-record-cards-service-types": "static-1.3788",
  "breeze-engine-chat-components": "static-1.717",
  "breeze-engine-core": "static-1.1017",
  "ably": "static-2.2",
  "highlight.js": "static-1.86",
  "content-media-composition-data-lib": "static-1.13240",
  "content-media-compositions": "static-2.17247",
  "media-bridge-lib": "static-1.19409",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16365",
  "browser-eslint": "static-2.57",
  "academy-common-lib": "static-1.14981",
  "nest": "static-1.541",
  "amplitude-session-replay-browser": "static-1.60",
  "prosemirror": "static-1.13",
  "sequences-client-types-lib": "static-1.8391",
  "breeze-artifacts-sdk": "static-1.341",
  "audio-components": "static-1.6347",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.37653",
  "html-to-image": "static-1.61",
  "urlinator": "static-1.4838",
  "video-components": "static-1.14150",
  "video-embed": "static-1.36640",
  "apps-service-types": "static-1.4044",
  "oauth-service-types": "static-1.4543",
  "ai-settings-ui-library": "static-1.8354",
  "nav-meta": "static-1.30473",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1064",
  "unified-auth-core-lib": "static-1.1208",
  "onboarding-data-sync-lib": "static-1.2516",
  "growth-onboarding-next-action-components": "static-1.2715",
  "user-context-client": "static-1.4811",
  "flux-actions": "static-1.368",
  "integrations-error-boundary-lib": "static-1.14451",
  "integrations-tracking-lib": "static-1.5912",
  "redux-observable": "static-1.75",
  "ReduxMessenger": "static-2.10675",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.926",
  "academy-service-client": "static-1.3992",
  "croppie": "static-2.10",
  "final-form": "static-1.78",
  "SafeStorage": "static-1.4709",
  "trellis-ecosystem": "static-1.7631",
  "ui-addon-video-player": "static-1.9008",
  "wootric-nps": "static-1.7201",
  "content-assistance-lib": "static-1.8202",
  "social-insights-client-types": "static-1.22706",
  "outpost": "static-1.4459",
  "simple-data-table": "static-1.3529",
  "InboxConnectUtils": "static-4.15559",
  "meetings-connect-utils-lib": "static-1.7914",
  "universal-page-editor-lib": "static-1.3313",
  "adobe-sign-auth-lib": "static-1.460",
  "ads-unified-auth-lib": "static-1.1380",
  "generic-oauth-auth-lib": "static-1.54",
  "google-sheets-integration-lib": "static-1.1029",
  "microsoft-drive-auth-lib": "static-1.143",
  "surveymonkey-integration-lib": "static-1.486",
  "slack-ui-library": "static-1.10704",
  "ui-coaching-tips": "static-1.29306",
  "hub-http-contrib": "static-1.3344",
  "ui-addon-sales-email": "static-1.5516"
},
  depPathPrefixes: {
  "billing-portal-ui": "/billing-portal-ui/static-1.2103",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.496",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5982",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8336",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10621",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.22",
  "react-dlb": "/react-dlb/static-1.88",
  "reselect": "/reselect/static-3.12",
  "billing-portal-service-types": "/billing-portal-service-types/static-1.1941",
  "commerce-products-lib": "/commerce-products-lib/static-1.10530",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19224",
  "customer-data-objects": "/customer-data-objects/static-1.7996",
  "customer-data-properties": "/customer-data-properties/static-1.52602",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8406",
  "data-fetching-client": "/data-fetching-client/static-1.9959",
  "foundations-assets": "/foundations-assets/static-1.5190",
  "foundations-components": "/foundations-components/static-1.8499",
  "foundations-theming": "/foundations-theming/static-1.4781",
  "framework-data-table": "/framework-data-table/static-2.12554",
  "hub-http": "/hub-http/static-1.6518",
  "HubStyleTokens": "/HubStyleTokens/static-2.11794",
  "I18n": "/I18n/static-7.1674",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.941",
  "metrics-js": "/metrics-js/static-1.9867",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49677",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1458",
  "property-translator": "/property-translator/static-1.5699",
  "purchase-motions-components": "/purchase-motions-components/static-1.6368",
  "quartz-config": "/quartz-config/static-1.1239",
  "quartz-core": "/quartz-core/static-1.6680",
  "quartz-routing": "/quartz-routing/static-1.891",
  "quick-fetch": "/quick-fetch/static-1.4131",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.192",
  "react-dom": "/react-dom/static-7.85",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1.17026",
  "redux": "/redux/static-4.76",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "rpc-client-utils": "/rpc-client-utils/static-1.4971",
  "sanitize-text": "/sanitize-text/static-1.8459",
  "smart-property-lib": "/smart-property-lib/static-1.8298",
  "styled-components": "/styled-components/static-2.95",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11287",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11452",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9381",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9840",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18390",
  "UIComponents": "/UIComponents/static-3.8740",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "immutable": "/immutable/static-2.83",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3622",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3738",
  "quartz-webpack": "/quartz-webpack/static-1.3685",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.539",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1524",
  "HeadJS": "/HeadJS/static-2.797",
  "quartz": "/quartz/static-1.7461",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3447",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "ts-schema": "/ts-schema/static-1.4296",
  "webpack-env": "/webpack-env/static-1.54",
  "bender-build-tools": "/bender-build-tools/static-1.3444",
  "commerce-permissions": "/commerce-permissions/static-1.1081",
  "customer-data-tracking": "/customer-data-tracking/static-1.7187",
  "growth-payments-core": "/growth-payments-core/static-1.26181",
  "hs-resources": "/hs-resources/static-1.496",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5182",
  "immer": "/immer/static-1.101",
  "products-iframe-lib": "/products-iframe-lib/static-1.8594",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11003",
  "pulse": "/pulse/static-1.934",
  "transmute": "/transmute/static-2.97",
  "batch-promise": "/batch-promise/static-1.1849",
  "crm_data": "/crm_data/static-4.92831",
  "cssUtils": "/cssUtils/static-1.926",
  "customer-data-associations": "/customer-data-associations/static-1.7631",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13335",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7197",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8227",
  "graphql": "/graphql/static-1.89",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-story-utils": "/hs-story-utils/static-1.9729",
  "HubStyle": "/HubStyle/static-2.12101",
  "icons": "/icons/static-2.683",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23835",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5558",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8001",
  "StyleGuideUI": "/StyleGuideUI/static-3.502",
  "ui-addon-opt": "/ui-addon-opt/static-4.8668",
  "ui-images": "/ui-images/static-2.1249",
  "usage-tracker-container": "/usage-tracker-container/static-1.7627",
  "usage-tracker-core": "/usage-tracker-core/static-1.7487",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4055",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9719",
  "atom": "/atom/static-1.5391",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2786",
  "calling-global-api": "/calling-global-api/static-1.65626",
  "calling-internal-common": "/calling-internal-common/static-1.31626",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67008",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59302",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4016",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4546",
  "crm-links": "/crm-links/static-1.6634",
  "crm-message-bus": "/crm-message-bus/static-1.43764",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4349",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9948",
  "external-options-client-types": "/external-options-client-types/static-1.4340",
  "file-manager-components": "/file-manager-components/static-1.24502",
  "formula-editor": "/formula-editor/static-1.14771",
  "google-libphonenumber": "/google-libphonenumber/static-1.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5900",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4428",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3911",
  "PatternValidationJS": "/PatternValidationJS/static-1.3198",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4183",
  "property-value-citations": "/property-value-citations/static-1.3216",
  "quartz-i18n": "/quartz-i18n/static-1.1136",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8408",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.144",
  "tiered-pricing": "/tiered-pricing/static-1.1958",
  "topics-actions-lib": "/topics-actions-lib/static-1.471",
  "trial-components-library": "/trial-components-library/static-1.14110",
  "usage-tracker": "/usage-tracker/static-1.7637",
  "user-context": "/user-context/static-1.5425",
  "zustand": "/zustand/static-1.85",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4768",
  "floating-ui": "/floating-ui/static-1.63",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2497",
  "react-aria": "/react-aria/static-1.72",
  "react-create-root-preference": "/react-create-root-preference/static-1.70",
  "react-virtualized": "/react-virtualized/static-2.107",
  "tanstack-table": "/tanstack-table/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.2651",
  "ui-fonts": "/ui-fonts/static-1.1056",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3264",
  "foundations-theming-base": "/foundations-theming-base/static-1.3766",
  "stylex": "/stylex/static-1.41",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13482",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10133",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.128",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "redux-thunk": "/redux-thunk/static-2.80",
  "reference-resolvers": "/reference-resolvers/static-1.8486",
  "reporting-data": "/reporting-data/static-1.68827",
  "sanitize": "/sanitize/static-1.4777",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5064",
  "hs-locale-management": "/hs-locale-management/static-1.296",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.91",
  "interframe": "/interframe/static-3.5060",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6051",
  "laboratory-lib": "/laboratory-lib/static-3.7457",
  "merchandise-lib": "/merchandise-lib/static-1.278",
  "onboarding-scopes": "/onboarding-scopes/static-1.6757",
  "purchase-motions-api": "/purchase-motions-api/static-1.6371",
  "signup-constants": "/signup-constants/static-1.19632",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8365",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.77",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.879",
  "hubspotter-http": "/hubspotter-http/static-1.4865",
  "jasmine": "/jasmine/static-4.4618",
  "jasmine-runner": "/jasmine-runner/static-1.6756",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.576",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.452",
  "quartz-auth": "/quartz-auth/static-1.1136",
  "quartz-head": "/quartz-head/static-1.1126",
  "quartz-test": "/quartz-test/static-1.1136",
  "quartz-tracking": "/quartz-tracking/static-1.840",
  "trellis-components": "/trellis-components/static-1.2670",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.15",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.381",
  "chirp-fetch": "/chirp-fetch/static-1.2198",
  "data-agent-kit": "/data-agent-kit/static-1.652",
  "data-token-picker": "/data-token-picker/static-1.16892",
  "feedback-loader": "/feedback-loader/static-1.29814",
  "markdown-it": "/markdown-it/static-1.6",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10704",
  "fsm": "/fsm/static-1.4054",
  "policy-lib": "/policy-lib/static-1.7106",
  "react-colorpicker": "/react-colorpicker/static-2.10522",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10767",
  "magpie-lib": "/magpie-lib/static-1.5757",
  "navigation-messaging": "/navigation-messaging/static-1.8163",
  "salesImages": "/salesImages/static-1.567",
  "seat-types-lib": "/seat-types-lib/static-1.729",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4961",
  "event-emitter": "/event-emitter/static-1.1258",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4222",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.316",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.641",
  "sales-views-client-types": "/sales-views-client-types/static-1.4561",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.437",
  "fast-json-patch": "/fast-json-patch/static-1.70",
  "crm_universal": "/crm_universal/static-1.22499",
  "customer-data-email": "/customer-data-email/static-1.18529",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8082",
  "superstore": "/superstore/static-1.5063",
  "sassPrefix": "/sassPrefix/static-1.197",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7102",
  "persist-promise": "/persist-promise/static-1.4006",
  "copilot-toolkit": "/copilot-toolkit/static-1.11851",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3366",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6889",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5386",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19263",
  "onboarding-tours": "/onboarding-tours/static-1.17122",
  "stripe-connect-js": "/stripe-connect-js/static-1.76",
  "chatspot-core": "/chatspot-core/static-1.23034",
  "ContentUtils": "/ContentUtils/static-1.69128",
  "calling-error-reporting": "/calling-error-reporting/static-1.31633",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11346",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6841",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2059",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7551",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6745",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10097",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1679",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1739",
  "immerable": "/immerable/static-1.4452",
  "video-components-external": "/video-components-external/static-1.12148",
  "video-data-lib": "/video-data-lib/static-1.35806",
  "bark-lib": "/bark-lib/static-1.16817",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.102",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6193",
  "react-codemirror": "/react-codemirror/static-1.10945",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15521",
  "hubs-service-types": "/hubs-service-types/static-1.1564",
  "navigation-components": "/navigation-components/static-1.18836",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19240",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18358",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1189",
  "stylex-utils": "/stylex-utils/static-1.141",
  "trellis-theming": "/trellis-theming/static-1.1279",
  "react-dnd-compat": "/react-dnd-compat/static-1.4922",
  "reporting-client-types": "/reporting-client-types/static-1.2687",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.78",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6054",
  "usage-tracker-public": "/usage-tracker-public/static-1.7448",
  "opentelemetry-web": "/opentelemetry-web/static-1.13",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10619",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "highcharts": "/highcharts/static-8.111",
  "trellis-story-utils": "/trellis-story-utils/static-1.4812",
  "storybook-react": "/storybook-react/static-1.40",
  "idb-keyval": "/idb-keyval/static-1.51",
  "magpie-types": "/magpie-types/static-1.5217",
  "reactive-lib": "/reactive-lib/static-1.1023",
  "simple-logging-lib": "/simple-logging-lib/static-1.3356",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5031",
  "sequences-lib": "/sequences-lib/static-1.8534",
  "FileManagerCore": "/FileManagerCore/static-1.40001",
  "FileManagerLib": "/FileManagerLib/static-1.40142",
  "timezone-utils": "/timezone-utils/static-2.5548",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10845",
  "immutable-less": "/immutable-less/static-1.4955",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18138",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20731",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8331",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4223",
  "ui-universal-auth": "/ui-universal-auth/static-1.9412",
  "growth-data-modal": "/growth-data-modal/static-1.5900",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2687",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5337",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10575",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7956",
  "cms-field-types": "/cms-field-types/static-1.5118",
  "content-icons-ui": "/content-icons-ui/static-1.2368",
  "integrations-lib": "/integrations-lib/static-1.17036",
  "underscore": "/underscore/static-1.8",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36836",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3788",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.717",
  "breeze-engine-core": "/breeze-engine-core/static-1.1017",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.86",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13240",
  "content-media-compositions": "/content-media-compositions/static-2.17247",
  "media-bridge-lib": "/media-bridge-lib/static-1.19409",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16365",
  "browser-eslint": "/browser-eslint/static-2.57",
  "academy-common-lib": "/academy-common-lib/static-1.14981",
  "nest": "/nest/static-1.541",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "prosemirror": "/prosemirror/static-1.13",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8391",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.341",
  "audio-components": "/audio-components/static-1.6347",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.37653",
  "html-to-image": "/html-to-image/static-1.61",
  "urlinator": "/urlinator/static-1.4838",
  "video-components": "/video-components/static-1.14150",
  "video-embed": "/video-embed/static-1.36640",
  "apps-service-types": "/apps-service-types/static-1.4044",
  "oauth-service-types": "/oauth-service-types/static-1.4543",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8354",
  "nav-meta": "/nav-meta/static-1.30473",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1064",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1208",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2516",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2715",
  "user-context-client": "/user-context-client/static-1.4811",
  "flux-actions": "/flux-actions/static-1.368",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14451",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5912",
  "redux-observable": "/redux-observable/static-1.75",
  "ReduxMessenger": "/ReduxMessenger/static-2.10675",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.926",
  "academy-service-client": "/academy-service-client/static-1.3992",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.78",
  "SafeStorage": "/SafeStorage/static-1.4709",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7631",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9008",
  "wootric-nps": "/wootric-nps/static-1.7201",
  "content-assistance-lib": "/content-assistance-lib/static-1.8202",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "outpost": "/outpost/static-1.4459",
  "simple-data-table": "/simple-data-table/static-1.3529",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15559",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7914",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3313",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.460",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1380",
  "generic-oauth-auth-lib": "/generic-oauth-auth-lib/static-1.54",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1029",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.143",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.486",
  "slack-ui-library": "/slack-ui-library/static-1.10704",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29306",
  "hub-http-contrib": "/hub-http-contrib/static-1.3344",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5516"
}
};
